<template>
    <div class="adjustPageOne">
        <div class="box" @click="toAdjust">
          <div class="btn"></div>
        </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "adjustPageOne",
    data() {
      return {
        campaignid: '',
        adgroupid: '',
        keyword: '',
        gclid: '',
        gbraid: '',
        wbraid: '',
        campaignName: '',
        campaignId: '',
        adsetName: '',
        adsetId: '',
        adName: '',
        adId: '',
        tracker_token: '',
        fbclid: '',
        fbpid: '',
        type:'', //1谷歌  2fb
        utm_id:'',
        utm_campaign:''
      };
    },
    created() {
      const urlParams = new URLSearchParams(window.location.search);
      this.utm_id = urlParams.get('utm_id'); 
      this.utm_campaign = urlParams.get('utm_campaign'); 
      const { campaignid, adgroupid, keyword, gclid, gbraid, wbraid, type } = this.$route.query;
      const { tracker_token, campaignName, adsetName, adsetId, adName, adId, fbclid, fbpid} = this.$route.query;
      this.campaignid = campaignid || 0;
      this.adgroupid = adgroupid || 0;
      this.keyword = keyword || 0;
      this.gclid = gclid || 0;
      this.gbraid = gbraid || 0;
      this.wbraid = wbraid || 0;
      this.type = type || 0;


      this.tracker_token = tracker_token || '';
      this.campaignName = campaignName || '';
      this.adsetName = adsetName || '';
      this.adsetId = adsetId || '';
      this.adName = adName || '';
      this.adId = adId || '';
      this.fbclid = fbclid || 0;
      this.fbpid = fbpid || 0;
      if(this.type == 2){
        this.appendHead();
        this.getUrl();
      }
    },
    methods: { 
      toAdjust(){
        if(this.type == 1){
          console.log('1')
          window.location.href = `https://app.adjust.com/1gntu7x9?campaign=${this.campaignid}&adgroup=${this.adgroupid}&creative=${this.keyword}&gclid=${this.gclid}&gbraid=${this.gbraid}&wbraid=${this.wbraid}`
        }else{
          console.log('this.campaignName',this.campaignName)
          console.log('this.campaignId',this.campaignId)
          console.log('this.adsetName',this.adsetName)
          console.log('this.adsetId',this.adsetId)
          console.log('this.adName',this.adName)
          console.log('this.adId',this.adId)
          console.log('this.fbclid',this.fbclid)
          console.log('this.fbpid',this.fbpid)
          // window.location.href = `https://app.adjust.com/1jm4devs?campaign=${this.campaignName}%20%28${this.campaignId}%29&adgroup=${this.adsetName}%20%28${this.adsetId}%29&creative=${this.adName}%20%28${this.adId}%29&fbclid=${this.fbclid}&fbpid=${this.fbpid}`
          window.location.href = `https://app.adjust.com/1jm4devs?campaign=${this.utm_campaign}%20%28${this.utm_id}%29&adgroup=${this.adsetName}%20%28${this.adsetId}%29&creative=${this.adName}%20%28${this.adId}%29&fbclid=${this.fbclid}&fbpid=${this.fbpid}`
        }
       
      },
      appendHead(){
        this.addElementToHead('script', {},`
          !function(f,b,e,v,n,t,s)
          {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
          n.callMethod.apply(n,arguments):n.queue.push(arguments)};
          if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
          n.queue=[];t=b.createElement(e);t.async=!0;
          t.src=v;s=b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t,s)}(window, document,'script',
          'https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', '594291956490956');
          fbq('track', 'PageView');`);
          const noscript = document.createElement('noscript');
          const img = document.createElement('img');
          img.src = 'https://www.facebook.com/tr?id=594291956490956&ev=PageView&noscript=1';
          img.height = '1';
          img.width = '1';
          noscript.appendChild(img);
          document.head.appendChild(noscript)
      },
      addElementToHead(tagName, attributes, innerHTML) {
          const element = document.createElement(tagName);
          for (const [key, value] of Object.entries(attributes)) {
              element.setAttribute(key, value);
          }
          if (innerHTML) {
              element.innerHTML = innerHTML;
          }
          document.head.appendChild(element);
      },
      buildURL(p0, p1, p2, p3, p4, p5, p6, fbclid, fbpid) {
        if (!p0) {
          return null;
        }
        tracker_token = p0;
        if (p1 || p2) {
          campaign = p1 + "(" + p2 + ")";
        } else {
          campaign = "";
        }
        if (p3 || p4) {
          adgroup = p3 + "(" + p4 + ")";
        } else {
          adgroup = "";
        }
        if (p5 || p6) {
          creative = p5 + "(" + p6 + ")";
        } else {
          creative = "";
        }
        if (!fbclid) {
          fbclid = "";
        }
        if (!fbpid) {
          fbpid = "";
        }
        // build a tracker URL
        let params = { campaign, adgroup, creative, fbclid, fbpid };
        let newURL =
          "https://app.adjust.com/" +
          tracker_token +
          "?" +
          Object.keys(params)
            .map((key) => key + "=" + encodeURIComponent(params[key]))
            .join("&");
        return newURL;
      },
      getFbPid() {
        let fbPid = document.cookie.match(/(^|;) ?_fbp=([^;]*)(;|$)/);
        if (fbPid) {
          return fbPid[2];
        } else {
          return null;
        }
      },
      getUrl(){
        // get query string, and parse it with URLSearchParams
        const urlParams = new URLSearchParams(window.location.search);
        //p0 = urlParams.get("p0") and fallback to "default"
        let p0 = urlParams.get("tracker_token") || 0;
        let p1 = urlParams.get("campaignName") || 0;
        let p2 = urlParams.get("campaignId") || 0;
        let p3 = urlParams.get("adsetName") || 0;
        let p4 = urlParams.get("adsetId") || 0;
        let p5 = urlParams.get("adName") || 0;
        let p6 = urlParams.get("adId") || 0;
        let fbPid = this.getFbPid();
        let fbClickId = urlParams.get("fbclid");
        let url = this.buildURL(p0, p1, p2, p3, p4, p5, p6, fbClickId, fbPid);
        // add links
        window.addEventListener("DOMContentLoaded", function () {
          if (url) {
            var elements = document.querySelectorAll(".AdjustTracker")
            for (var i = 0; i < elements.length; i++) {
              elements[i].setAttribute("href", url);
              
            }
          }
        });
      }
    },
  };
  </script>
  
  <style scoped>
  .adjustPageOne{
    width: 100vw;
  padding-bottom: 80px;
  }
  .box{
    margin-top: 24px;
    width: 100%;
    height: 3036px;
    background: url('../../assets/adjustPage/oneBg.png') no-repeat;
    background-size: 100% 100%;
  }
  .btn{
    width: 503px;
    height: 164px;
    background: url('../../assets/adjustPage/downloadBtn.png') no-repeat;
    background-size: 100% 100%;
    position: fixed;
    left: 50%;
    bottom: 32px;
    transform: translateX(-50%);
  }
  </style>
  